import React, { useState } from "react";
import Spacing from "../Spacing";
import { ArrowLeft, Loader } from "lucide-react";
import { formatToDateTime, notify, time12HourFormat } from "../../helpers";
import { createNewScheduler } from "../../services/users";

const SchedulerDateTimeSection = (props) => {
  const {
    templateMessage = "",
    handleSchedulerInputChange = () => {},
    schedulerForm = {},
    setSchedulerForm = () => {},
    defaultValues = {},
    setActiveSchedulerTab = () => {},
    reloadData = () => {},
    account_id = "",
    location_id = "",
    setOpenModal = () => {}
  } = props;

  // Function to get current date and time in the required format
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const now = new Date();
  // Get hours and minutes in local time
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const currentTime = `${hours}:${minutes}`;

  const today = daysOfWeek[now.getDay()]; 
  const [confirmSchedulerLoader, setConfirmSchedulerLoader] = useState(false);

  const handleScheduleDateTimeChange = (e) => {
    const {name, value } = e.target;
    setSchedulerForm({...schedulerForm, [name]: value});
  };

  const changeSchedulerTime = (value) => {
    if(value === 1) {
      setSchedulerForm((prev) => ({
        ...prev,
        message_send_type: "now",
      }));
    } else if(value === 2) {
      setSchedulerForm((prev) => ({
        ...prev,
        message_send_type:"later",
        msg_later_datetime:getCurrentDateTime(),
      }));
    } else if(value === 3) {
      setSchedulerForm((prev) => ({
        ...prev,
        message_send_type:"regularly",
        msg_later_datetime: "",
        regular_msg_frequency_day: today,
        regular_msg_frequency_time: currentTime,
      }));
    } else {
      setSchedulerForm((prev) => ({
        ...prev,
        message_send_type: "now",
        msg_later_datetime: "",
        regular_msg_frequency: "",
        regular_msg_frequency_day: "",
        regular_msg_frequency_time: ""
      }));
    }
  };
  
  const handelSchedulerSubmit = async (e) => {
    e.preventDefault();

    if(schedulerForm?.message_send_type === "regularly" && schedulerForm?.regular_msg_frequency === "") {
      notify("error", "Please select an repeat time");
      return;
    }

    try {
      setConfirmSchedulerLoader(true);

      const result = await createNewScheduler(schedulerForm);
      
      if(result){
        if(result?.data?.status === 'success'){
          notify("success", result?.data?.message);
          setSchedulerForm(defaultValues)
          setActiveSchedulerTab(0);
          setOpenModal();
          await reloadData(account_id, location_id);
        } else {
          notify("error", result?.data?.message);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail);
      }
    } finally {
      setConfirmSchedulerLoader(false);
    }
  }

  return (
    <div className="scheduler_message_template setup-scheduler-page" style={{ height: '100%' }}>
      <h4 className="docpro_mb_0">Almost There. <br /> When should we send this text out?</h4>
      <Spacing lg="30" sm="30" />

      <div className="docpro_grid docpro_grid_col_2" style={{ height: '78%' }}>
        <form onSubmit={handelSchedulerSubmit} style={{ height: '100%' }}>
          <div className="modal_height_100">
            <div className="target_patient">
              <label
                className="docpro_fw_500 docpro_primary_color"
                style={{ textAlign: "left" }}
              >
                Send this message....
              </label>
              <div className="docpro_tab_btns_2">
                <button
                  type="button"
                  className={`${schedulerForm?.message_send_type === "now" ? "active" : ""}`}
                  onClick={() => changeSchedulerTime(1)}
                >
                  Now
                </button>
                <button
                  type="button"
                  className={`${schedulerForm?.message_send_type === "later" ? "active" : ""}`}
                  onClick={() => changeSchedulerTime(2)}
                >
                  Later
                </button>
                <button
                  type="button"
                  className={`${schedulerForm?.message_send_type === "regularly" ? "active" : ""}`}
                  onClick={() => changeSchedulerTime(3)}
                >
                  Regularly
                </button>
              </div>
              <Spacing lg="25" sm="25" />

              <div>
                {schedulerForm?.message_send_type === "now" && (
                  <>
                    <p style={{ textAlign: "left" }}>
                      We will send the message right away to the patients.
                    </p>
                  </>
                )}
                {schedulerForm?.message_send_type === "later" && (
                  <>
                    <input
                      type="datetime-local"
                      id="datetime"
                      name="msg_later_datetime"
                      value={schedulerForm?.msg_later_datetime}
                      onChange={handleScheduleDateTimeChange}
                      style={{
                        width: "100%",
                        padding: "10px",
                        fontSize: "16px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <Spacing lg="10" sm="10" />
                    <p style={{ textAlign: "left" }}>
                      Will send on {formatToDateTime(schedulerForm?.msg_later_datetime)}
                    </p>
                  </>
                )}
                {schedulerForm?.message_send_type === "regularly" && (
                  <>
                    <label className="docpro_fw_500 docpro_primary_color" style={{textAlign:"left"}}> 
                      Repeat It
                    </label>
                    <select
                      defaultValue={schedulerForm?.regular_msg_frequency}
                      name="regular_msg_frequency"
                      className="docpro_form_field size_lg"
                      onChange={handleScheduleDateTimeChange}
                    >
                      <option value="" disabled>Select Frequency</option>
                      <option value="day">Every Day</option>
                      <option value="week">Every Week</option>
                      <option value="month">Every Month</option>
                      <option value="year">Every Year</option>
                    </select>

                    {["day", "week", "month", "year"].includes(schedulerForm?.regular_msg_frequency) && (
                      <>
                        <Spacing lg="20" sm="20" />
                        <label className="docpro_fw_500 docpro_primary_color" style={{textAlign: "left"}} >
                          Select Send Time:
                        </label>
                        <input
                          type="time"
                          className="docpro_form_field size_lg"
                          defaultValue={schedulerForm?.regular_msg_frequency_time}
                          name="regular_msg_frequency_time"
                          onChange={(e) => {
                            handleSchedulerInputChange(e);
                          }}
                        />
                      </>
                    )}

                    {["week", "month", "year"].includes(schedulerForm?.regular_msg_frequency) && (
                      <>
                        <Spacing lg="20" sm="20" />
                        <label className="docpro_fw_500 docpro_primary_color" style={{textAlign: "left"}}>
                          Select Send Day:
                        </label>
                        <select
                          className="docpro_form_field size_lg"
                          defaultValue={schedulerForm?.regular_msg_frequency_day}
                          name="regular_msg_frequency_day"
                          onChange={(e) => {
                            handleSchedulerInputChange(e);
                          }}
                        >
                          {daysOfWeek.map((day) => (
                            <option key={day} value={day}>
                              {day}
                            </option>
                          ))}
                        </select>
                      </>
                    )}

                    <Spacing lg="10" sm="10" />
                    {schedulerForm?.regular_msg_frequency === "month" && schedulerForm?.regular_msg_frequency_time && schedulerForm?.regular_msg_frequency_day && (
                      <p style={{ textAlign: "left" }}>
                        We send out SMS at {time12HourFormat(schedulerForm?.regular_msg_frequency_time)} on the first {schedulerForm?.regular_msg_frequency_day} of the
                        month.
                      </p>
                    )}
                    {schedulerForm?.regular_msg_frequency === "week" && schedulerForm?.regular_msg_frequency_time && schedulerForm?.regular_msg_frequency_day && (
                      <p style={{ textAlign: "left" }}>
                        We send out SMS at {time12HourFormat(schedulerForm?.regular_msg_frequency_time)} every {schedulerForm?.regular_msg_frequency_day}.
                      </p>
                    )}
                    {schedulerForm?.regular_msg_frequency === "year" && schedulerForm?.regular_msg_frequency_time && schedulerForm?.regular_msg_frequency_day && (
                      <p style={{ textAlign: "left" }}>
                        We send out SMS at {time12HourFormat(schedulerForm?.regular_msg_frequency_time)} on the first {schedulerForm?.regular_msg_frequency_day} of the
                        year.
                      </p>
                    )}
                    {schedulerForm?.regular_msg_frequency === "day" && schedulerForm?.regular_msg_frequency_time && (
                      <p style={{ textAlign: "left" }}>
                        We send out SMS at {time12HourFormat(schedulerForm?.regular_msg_frequency_time)} every day.
                      </p>
                    )}
                  </>
                )}
              </div>
              <Spacing lg="30" sm="30" />
            </div>

            <div className="docpro_scheduler_page_btn" style={{ width: '100%', margin: 'auto 0 15px 0' }}>
              <button type="button"
                onClick={() => {setActiveSchedulerTab(3);}}
                className="docpro_bordered_btn docpro_fw_600 size_lg"
              >
                <ArrowLeft width={16} height={16} className="mr-2" />
                <span>Back</span>
              </button>
              <button
                type="submit"
                className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                disabled={confirmSchedulerLoader ? true : false}
              >
                <span>Confirm</span>
                {confirmSchedulerLoader && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
            </div>
          </div>
        </form>

        <div className="template_message_mobile">
          <img src="/images/phone_case.png" alt="Mobile Phone Case" />
          {templateMessage ? (
            <div className="" style={{ padding: "6px" }}>
              <p>{templateMessage}</p>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default SchedulerDateTimeSection;
